import {
  Box,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Stack,
  TextField,
} from '@mui/material'
import React from 'react'
import DetailsBox, { DetailRow } from '../../../../components/Cards/DetailsBox'

const Investigation = ({ incident, handleChange }) => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} lg={6}>
        <FormControl fullWidth>
          <InputLabel>Harm</InputLabel>
          <Select
            value={incident?.result ?? ''}
            onChange={(e) => handleChange('result', e.target.value)}
            label="Result"
          >
            <MenuItem value="Harm">Harm</MenuItem>
            <MenuItem value="Near Miss">Near Miss</MenuItem>
            <MenuItem value="No Harm">No Harm</MenuItem>
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={12} lg={6}>
        <FormControl fullWidth>
          <InputLabel>Actual Impact</InputLabel>
          <Select
            value={incident?.actualImpact ?? ''}
            onChange={(e) => handleChange('actualImpact', e.target.value)}
            label="Actual Impact"
          >
            <MenuItem value="No Injury or Loss">No Injury or Loss</MenuItem>
            <MenuItem value="Not Applicable">Not Applicable</MenuItem>
            <MenuItem value="Minor injury or minor loss">
              Minor injury or minor loss
            </MenuItem>
            <MenuItem value="Moderate Injury or moderate loss">
              Moderate Injury or moderate loss
            </MenuItem>
            <MenuItem value="Serious harm or significant loss">
              Serious harm or significant loss
            </MenuItem>
            <MenuItem value="Very Significant Loss">
              Very Significant Loss
            </MenuItem>
            <MenuItem value="Very Serious Harm">Very Serious Harm</MenuItem>
            <MenuItem value="Death">Death</MenuItem>
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={12}>
        <Stack gap={2}>
          <TextField
            label="What Happened"
            value={incident?.whatHappened ?? ''}
            onChange={(e) => handleChange('whatHappened', e.target.value)}
            fullWidth
            autoComplete="off"
            minRows={2}
            multiline
          />
          <TextField
            label="Why it happened"
            value={incident?.whyItHappened ?? ''}
            onChange={(e) => handleChange('whyItHappened', e.target.value)}
            fullWidth
            autoComplete="off"
            minRows={2}
            multiline
          />
          <TextField
            label="How it happened"
            value={incident?.howItHappened ?? ''}
            onChange={(e) => handleChange('howItHappened', e.target.value)}
            fullWidth
            autoComplete="off"
            minRows={2}
            multiline
          />
          <TextField
            label="What actions have been taken?"
            value={incident?.whatActions ?? ''}
            onChange={(e) => handleChange('whatActions', e.target.value)}
            fullWidth
            autoComplete="off"
            minRows={2}
            multiline
          />
          <TextField
            label="What concerns have been identified?"
            value={incident?.concernsIdentified ?? ''}
            onChange={(e) => handleChange('concernsIdentified', e.target.value)}
            fullWidth
            autoComplete="off"
            minRows={2}
            multiline
          />
          <TextField
            label="What mitigation is there?"
            value={incident?.mitigationsPositives ?? ''}
            onChange={(e) =>
              handleChange('mitigationsPositives', e.target.value)
            }
            fullWidth
            autoComplete="off"
            minRows={2}
            multiline
          />
          <TextField
            label="Describe the Investigation Process"
            value={incident?.investigationProcess ?? ''}
            onChange={(e) =>
              handleChange('investigationProcess', e.target.value)
            }
            fullWidth
            autoComplete="off"
            minRows={2}
            multiline
          />
          <TextField
            label="What are the root causes?"
            value={incident?.rootCauses ?? ''}
            onChange={(e) => handleChange('rootCauses', e.target.value)}
            fullWidth
            autoComplete="off"
            minRows={2}
            multiline
          />
          <TextField
            label="What systemic issues contributed to this incident?"
            value={incident?.systemicIssues ?? ''}
            onChange={(e) => handleChange('systemicIssues', e.target.value)}
            fullWidth
            autoComplete="off"
            minRows={2}
            multiline
          />
        </Stack>
      </Grid>
    </Grid>
  )
}

export default Investigation
